import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { sleep } from '../common';
import { useBoolState } from './useHook';
/**
 * サムネイル兼スライダーのコンポーネントを制御するためのuse
 * @param config
 * @returns {*}
 */
const useThumbnailCustomSlider = (config = {}) => {
    const sliderRef = useRef();
    const [slideIndex, changeSlideIndex] = useState(0);
    const setSliderRef = useCallback((slide) => {
        sliderRef.current = slide;
    }, [sliderRef]);
    const { boolState: isEnter, changeFalse: onMouseLeave, changeTrue: onMouseEnter, } = useBoolState(false);
    useEffect(() => {
        let active = true;
        if (isEnter) {
            // 要素がマウスオーバーされていたらautoplayっぽい動きにする
            sleep(1).then(() => {
                if (active) {
                    sliderRef.current.slickNext();
                    sliderRef.current.slickPlay();
                }
            });
        }
        else {
            // 要素がマウスオーバーされていなければautoplayを停止
            sliderRef.current.slickPause();
        }
        return () => {
            active = false;
        };
    }, [isEnter, sliderRef]);
    const customConfig = useMemo(() => (Object.assign({ afterChange: changeSlideIndex, arrows: false, autoplay: true, autoplaySpeed: 1000, infinite: true, pauseOnHover: false, slidesToShow: 1, speed: 300, swipeToSlide: false }, config)), [changeSlideIndex, config]);
    return {
        config: customConfig,
        isEnter,
        onMouseEnter,
        onMouseLeave,
        setSliderRef,
        slideIndex,
        sliderRef,
    };
};
export const useThumbnailSlider = {
    useThumbnailCustomSlider,
};
export default useThumbnailSlider;
